import React, { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useAdminLanguage } from "../../../context/AdminLanguageContext";
import StatsCrossService from "../../../services/StatsCrossService";
import AdminCrossBoardService from "../board/AdminCrossBoardService";
import BedrockIdeaService from "../../setting/bedrock_idea/BedrockIdeaService";
import WordPuzzleTagStatsPanel from "../../pzl_common/stats/WordPuzzleTagStatsPanel";

export default function AdminCrossStatsMain() {
    const { language } = useAdminLanguage();
    const fetchStats = useCallback((lang) => StatsCrossService.statsByTag(lang), []);
    const publishReviewed = useCallback(
        (batchSize, lang, tag) => AdminCrossBoardService.publishReviewed(batchSize, lang, tag),
        [],
    );
    const generateIdea = useCallback((tag) => BedrockIdeaService.genDraftByTag(tag), []);

    return (
        <Box
            sx={{
                p: 2,
                minHeight: "100%",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Typography variant="h5" sx={{ fontWeight: 600, color: "primary.main", mb: 1, flexShrink: 0 }}>
                Crossword Statistics
            </Typography>
            <WordPuzzleTagStatsPanel
                language={language}
                fetchStats={fetchStats}
                publishReviewed={publishReviewed}
                generateIdea={generateIdea}
                dashboardPath="/admin/puzzle/cross_board"
                puzzleLabel="crossword"
                sortStorageKey="admin.cross.tagStats.sort"
            />
        </Box>
    );
}
